import React from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'

import typography from '../../utils/typography'
import assetLogo from '../../vectors/logo-citygate-block.svg'

const Logo = styled(({ theme, compact, ...rest }) => <Link {...rest} />)`
  display: block;
  position: relative;
  z-index: ${(props) => (props.compact ? 2 : 3)};
  height: ${(props) =>
    props.compact ? typography.rhythm(1.3) : typography.rhythm(2)};
  background: url(${assetLogo}) no-repeat center;
  background-color: ${(props) => props.theme.colors.blue};
  background-size: ${(props) => (props.compact ? '150px' : 'contain')};
  border-bottom: 1px ${(props) => props.theme.colors.blue} solid;
  h1,
  span {
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
  }
  &::after {
    display: ${(props) => (props.compact ? 'none' : 'block')};
    content: '';
    position: absolute;
    right: 0;
    opacity: 0.15;
    height: 99.5%;
    width: 6px;
    transform: translateX(100%);
    background-image: linear-gradient(270deg, #dfdfdf 0%, black 100%);
  }
`

class HeaderLogo extends React.PureComponent {
  render() {
    const isRoot = this.props.location === '/'
    const seoSiteHeading = isRoot ? <h1>Citygate</h1> : <span>Citygate</span>
    return (
      <Logo compact={this.props.compact} to="/">
        {seoSiteHeading}
      </Logo>
    )
  }
}

HeaderLogo.defaultProps = {
  location: '/'
}
HeaderLogo.propTypes = {
  location: string
}

export default HeaderLogo
